import {liveKitRoomConstants} from "@data/constants/liveModeConstants";

export function setLiveKitToken(token, roomName = null) {
  return { type: liveKitRoomConstants.SET_LIVEKIT_TOKEN, token, roomName }
}

/** Le micro que la salle n'ouvre pas d'elle-même (`microphoneHeld`), tenu par le live de l'élève (`useMicGate`). */
export function holdLiveKitMicrophone(held) {
  return { type: liveKitRoomConstants.HOLD_LIVEKIT_MICROPHONE, held }
}
